import { serviceRoleApi } from 'api';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';

export const callDeleteServiceRole = async (serviceRoleUid: string): Promise<ServiceAgreementV2> => {
  return serviceRoleApi.deleteServiceRole({ serviceRoleUid });
};
